import { getContext } from '@/assets/js/mapContext';
import { Modify } from 'ol/interaction';

export default {
  methods: {
    toggleRetailZonesModify(value, callback = () => {}) {
      if (!value) return this.map.removeInteraction(this.getInteractionByName('retailZonesModify'));
      const zonesLayer = this.getLayerById('retail-zones');
      if (!zonesLayer) throw Error(`Layer retail-zones doesn't exist`);
      const modifyInteraction = new Modify({
        source: zonesLayer.getSource(),
      });
      modifyInteraction.on('modifyend', e => callback(e));
      modifyInteraction.set('name', 'retailZonesModify');
      this.map.addInteraction(modifyInteraction);
    },
  },
  mounted() {
    getContext(this).$off('retail-zones-modify-action');
    getContext(this).$on('retail-zones-modify-action', this.toggleRetailZonesModify);
  },
};
